module.exports = __webpack_public_path__ + "static/media/CreateReturn1.1c63572c.png";